var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "bagStep2",
      staticClass: "row",
      class: _vm.classesCableSelectionWrapper,
    },
    [
      _c("LoadingOverlay", {
        attrs: {
          active: _vm.displayLoader,
          id: "loader",
          loader: "dots",
          color: "#1A74DB",
          height: "30",
          width: "100%",
          opacity: "0.85",
        },
        on: {
          "update:active": function ($event) {
            _vm.displayLoader = $event
          },
        },
      }),
      _vm._v(" "),
      _vm.bagStep < 2 && !_vm.isCableAccessoriesPage
        ? _c("div", { staticClass: "cover-up" })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col xs-12 md-12 lg-12",
          attrs: { id: "cable-selection" },
        },
        [
          _vm.displayVehicleCableSelectionOptions
            ? _c(
                "div",
                { staticClass: "cable-selection-1", class: _vm.classesOptions },
                [
                  _vm.showAdditionalAccessoryQuestion
                    ? _c("Question", {
                        attrs: {
                          title:
                            _vm.activeOffer.oneToOneAccessory.question_content
                              .title,
                          subtitle:
                            _vm.activeOffer.oneToOneAccessory.question_content
                              .subtitle,
                          options:
                            _vm.activeOffer.oneToOneAccessory.question_content
                              .available_answers,
                          selectedOption: _vm.selectedAdditionalAccessoryOption,
                        },
                        on: { onOptionClick: _vm.additionalAccessoryHandler },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-12/12 max-w-[1200px] md:flex justify-between",
                      },
                      [
                        !_vm.isCableAccessoriesPage
                          ? _c(
                              "div",
                              { staticClass: "w-12/12 mb-1 md:mb-0 md:w-5/12" },
                              [
                                _c("p", { staticClass: "bold m-0 steps" }, [
                                  _vm._v("Step 3 of " + _vm._s(_vm.totalSteps)),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "bold leading-none text-blue-dark md:max-w-[300px] mb-1/2",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.webstoreContent.cartPage
                                            .specify_cables
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-blue-dark text-normal mt-1/2 md:text-xl mb-2",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.cableSelectionInstructions.replaceAll(
                                            "(s)",
                                            this.cablesNeededCount === 1
                                              ? ""
                                              : "s"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.displayNACableSelection
                          ? _c(
                              "div",
                              {
                                staticClass: "roboto text-center",
                                class: _vm.isCableAccessoriesPage
                                  ? "w-12/12"
                                  : "w-6/12",
                              },
                              [
                                _vm.showOptions("vin")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cable-matching-options cursor-pointer w-4/12",
                                        attrs: { id: "vin" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleOptionClick("vin")
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "method-wrapper !w-auto flex flex-col p-1 mx-gap2 shadow--custom rounded-[14px] h-full min-h-[220px] md:min-h-[100px] md:p-2 border-3 border-white",
                                            class: _vm.cableOptionClass("vin"),
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mb-1/2 tab--recommended w-full text-center text-sm text-white leading-[24px] rounded-[4px] font-semibold md:max-w-[130px] md:h-fit",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.webstoreContent
                                                        .cartPage.recommended
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pt-0 md:text-left md:w-9/12",
                                              },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "text-blue-dark text-xl font-bold md:m-0",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.webstoreContent
                                                            .cartPage
                                                            .input_vin_no_title
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-blue-dark text-md",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.webstoreContent
                                                            .cartPage.vin_sub
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showOptions("mmy")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cable-matching-options cursor-pointer w-4/12",
                                        attrs: { id: "mmy" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleOptionClick("mmy")
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "method-wrapper !w-auto flex flex-col p-1 mx-gap2 shadow--custom rounded-[14px] h-full min-h-[220px] md:min-h-[100px] md:p-2 border-3 border-white",
                                            class: _vm.cableOptionClass("mmy"),
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "mb-1/2 tab--recommended bg-blue-default w-full text-center text-sm text-white leading-[24px] rounded-[4px] font-semibold md:max-w-[130px] md:h-fit",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.webstoreContent
                                                        .cartPage.recommended
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pt-0 md:text-left md:w-9/12",
                                              },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "text-blue-dark text-xl font-bold md:m-0",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.activeProductKey.includes(
                                                            "AG"
                                                          )
                                                            ? _vm
                                                                .webstoreContent
                                                                .cartPage
                                                                .asset_selection_title
                                                            : _vm
                                                                .webstoreContent
                                                                .cartPage
                                                                .vehicle_selection_title
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-blue-dark text-md",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.activeProductKey.includes(
                                                            "AG"
                                                          )
                                                            ? _vm
                                                                .webstoreContent
                                                                .cartPage
                                                                .asset_sub
                                                            : _vm
                                                                .webstoreContent
                                                                .cartPage
                                                                .make_model_sub
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showOptions("plug type")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cable-matching-options cursor-pointer w-4/12",
                                        attrs: { id: "plug-type" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleOptionClick(
                                              "plug type"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "method-wrapper !w-auto flex flex-col p-1 mx-gap2 shadow--custom rounded-[14px] h-full min-h-[220px] md:min-h-[120px] md:p-2 border-3 border-white",
                                            class:
                                              _vm.cableOptionClass("plug type"),
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pt-0 md:text-left md:w-9/12 md:mt-0",
                                              },
                                              [
                                                _c(
                                                  "h4",
                                                  {
                                                    staticClass:
                                                      "text-blue-dark text-xl font-bold md:m-0",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.webstoreContent
                                                            .cartPage.plug_type
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "text-blue-dark text-md",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.activeProductKey.includes(
                                                            "AG"
                                                          )
                                                            ? _vm
                                                                .webstoreContent
                                                                .cartPage
                                                                .asset_type_sub
                                                            : _vm
                                                                .webstoreContent
                                                                .cartPage
                                                                .cable_type_sub
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _c("div", { staticClass: "row flex flex-row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cable-matching-options cursor-pointer w-1/3",
                                  class:
                                    _vm.cableOptionClass("emea-mmy-selection"),
                                  attrs: { id: "mmy" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeCableMethod(
                                        "emea-mmy-selection"
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.webstoreContent.cartPage
                                          .vehicle_selection_title
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]),
                      ]
                    ),
                  ],
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: _vm.isCableAccessoriesPage
                ? "cableSelect"
                : _vm.displayVehicleCableSelectionOptions
                ? "bagStep3"
                : "bagStep2",
              staticClass: "h-fit",
              class: [
                _vm.displayVehicleCableSelectionOptions
                  ? _vm.bagStep < 3 && !_vm.isCableAccessoriesPage && "grayed"
                  : _vm.bagStep < 2 && "grayed",
                _vm.isCableAccessoriesPage
                  ? "overflow-visible"
                  : "overflow-hidden md:h-screen",
              ],
            },
            [
              (!_vm.isCableAccessoriesPage &&
                _vm.displayVehicleCableSelectionOptions &&
                _vm.bagStep < 3) ||
              (!_vm.displayVehicleCableSelectionOptions && _vm.bagStep < 2)
                ? _c("div", { staticClass: "cover-up" })
                : _vm._e(),
              _vm._v(" "),
              _vm.displayNACableSelection
                ? _c(
                    "div",
                    {
                      staticClass: "padding-bottom",
                      attrs: { id: "selection-options" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-12/12 max-w-[1200px] md:flex justify-between",
                        },
                        [
                          !_vm.isCableAccessoriesPage
                            ? _c(
                                "div",
                                { staticClass: "w-12/12 md:w-4/12" },
                                [
                                  _c("div", { staticClass: "roboto" }, [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "bold m-0 md:text-left steps",
                                      },
                                      [
                                        _vm._v(
                                          "\n                Step " +
                                            _vm._s(
                                              _vm.onlyOneCableSelectionMethod
                                                ? "3"
                                                : "4"
                                            ) +
                                            " of\n                " +
                                            _vm._s(_vm.totalSteps) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "text-blue-dark md:text-left md:mb-1/2 md:mt-1/2",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.webstoreContent.cartPage.general_cable_select
                                                .replace(
                                                  "cables_needed_count",
                                                  this.cablesNeededCount === 1
                                                    ? ""
                                                    : this.cablesNeededCount
                                                )
                                                .replaceAll(
                                                  "(s)",
                                                  this.cablesNeededCount === 1
                                                    ? ""
                                                    : "s"
                                                )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "mt-1/2 text-blue-dark text-xl",
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.totalCablesSubmittedCount ===
                                                0
                                                ? "No cables selected"
                                                : `${_vm.totalCablesSubmittedCount} out of ${_vm.cablesNeededCount} cables selected`
                                            ) +
                                            "\n                "
                                        ),
                                        _vm.totalCablesSubmittedCount ===
                                        _vm.cablesNeededCount
                                          ? _c(
                                              "span",
                                              { staticClass: "check" },
                                              [_vm._v("✓")]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("SelectionInfo", {
                                    attrs: {
                                      cableSkuToNames: _vm.cableSkuToNames,
                                      shift: false,
                                    },
                                    on: {
                                      "change-cable-selection-type":
                                        _vm.changeCableMethodEvent,
                                      "add-selection-method":
                                        _vm.addCableSelectionMethod,
                                      clear: _vm.clearAllData,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cable-type-select mt-1",
                              class: _vm.isCableAccessoriesPage
                                ? "w-12/12"
                                : "md:mt-0 md:w-7/12",
                            },
                            [
                              _c(
                                "div",
                                {
                                  ref: "desktopScrollWrapper",
                                  staticClass:
                                    "cable-scroll-wrapper h-fit p-b-8",
                                  class: _vm.isCableAccessoriesPage
                                    ? "overflow-visible"
                                    : "md:h-screen overflow-scroll",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: _vm.isCableAccessoriesPage
                                        ? ""
                                        : "padding-wrapper",
                                    },
                                    [
                                      _vm._l(
                                        _vm.activeCableSelectionMethods,
                                        function (method, index) {
                                          return [
                                            _c(
                                              _vm.cableMethodComponent(method),
                                              {
                                                key: method,
                                                ref: method,
                                                refInFor: true,
                                                tag: "component",
                                                attrs: {
                                                  addToCart: _vm.addToCart,
                                                  isCableAccessoriesPage:
                                                    _vm.isCableAccessoriesPage,
                                                  selectedTypeOfReplacementCable:
                                                    _vm.selectedTypeOfReplacementCable,
                                                  noProductImage:
                                                    _vm.webstoreContent
                                                      .noProductImage,
                                                  webstoreContent:
                                                    _vm.webstoreContent,
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex justify-between cable-title-border pt-1 pb-0",
                                                      },
                                                      [
                                                        _c(
                                                          "h3",
                                                          {
                                                            staticClass:
                                                              "text-blue-dark text-xl mt-0 mb-0",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm
                                                                    .webstoreContent
                                                                    .cartPage
                                                                    .specific_cable_selection_title[
                                                                    _vm.activeProductKey.includes(
                                                                      "AG"
                                                                    ) &&
                                                                    method ===
                                                                      "mmy"
                                                                      ? "mmyAG"
                                                                      : method
                                                                  ]
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "close-out",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.removeCableSelectionMethod(
                                                                  method,
                                                                  index
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_c("Trash")],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.webstoreContent.cartPage
                                                      .specific_cable_selection_subtitle[
                                                      _vm.activeProductKey.includes(
                                                        "AG"
                                                      ) && method === "mmy"
                                                        ? "mmyAG"
                                                        : method
                                                    ]
                                                      ? _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "text-blue-dark text-base mt-1/2 mb-0 pb-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                        " +
                                                                _vm._s(
                                                                  _vm
                                                                    .webstoreContent
                                                                    .cartPage
                                                                    .specific_cable_selection_subtitle[
                                                                    _vm.activeProductKey.includes(
                                                                      "AG"
                                                                    ) &&
                                                                    method ===
                                                                      "mmy"
                                                                      ? "mmyAG"
                                                                      : method
                                                                  ]
                                                                ) +
                                                                "\n                      "
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ],
                                              2
                                            ),
                                          ]
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm.isCableAccessoriesPage
                                        ? _c("SelectionInfo", {
                                            attrs: {
                                              isCableAccessoriesPage:
                                                _vm.isCableAccessoriesPage,
                                              cableSkuToNames:
                                                _vm.cableSkuToNames,
                                              shift: false,
                                            },
                                            on: {
                                              "change-cable-selection-type":
                                                _vm.changeCableMethodEvent,
                                              "add-selection-method":
                                                _vm.addCableSelectionMethod,
                                              clear: _vm.clearAllData,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _c(
                    "div",
                    { attrs: { id: "selection-options" } },
                    [
                      _c("EmeaMmyInput", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.mainSelectCableMethod == "emea-mmy-selection",
                            expression:
                              "mainSelectCableMethod == 'emea-mmy-selection'",
                          },
                        ],
                      }),
                    ],
                    1
                  ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }